import { useQuery } from "react-query";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useGetContractsStats = (
  schoolId,
  trainingId,
  accessToken
) => {
  return useQuery(
    ["contracts-stats", schoolId, trainingId, accessToken],
    async () => {
      try {
        const response = await fetch(
          BACKEND_URL +
          `/api/v1/schools/${schoolId}/trainings/${trainingId}/contracts-stats`,
          {
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch contracts statistics!");
        }
        if (response.status >= 299) {
          throw new Error("Erreur de récupération des statistiques des contrats!");
        }
        const result = await response.json();
        return result;
      } catch (error) {
        console.error("Error fetching contracts statistics:", error);
        throw error;
      }
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};

const contractsStatsAPI = {
  useGetContractsStats,
};

export default contractsStatsAPI;
